/*
    Filter for selecting which queued messages to display,
    with fields for location, routes, lanes, start & end dates
*/

import React from "react";

import MainContext from "../MainContext";

import LocationDropDown from "../Components/LocationDropDown";
import DateInput from "../Components/DateInput";

import { getRoutes, getLanes } from "../Requests/UtilityRequests";

export default class MessageGeneralFilter extends React.Component {

    static contextType = MainContext;

    constructor(){
        super();
        
        this.state = {
            location: "",
            routes: [],
            route: "",
            lanes: [],
            lane: "",
            startDate: new Date(),
            endDate: new Date()
        };
    }

    updateValue = (evt) => {
        const targetName = evt.target.name;
        this.setState({[evt.target.name]: evt.target.value}, () => {
            if(targetName === "location"){
                this.locationSelected();
            }
            else if(targetName === "route"){
                this.routeSelected();
            }
        });
    }


    // the various filter fields have cascading values based on previous value selections
    // and so these will be called on selection to provide an accurate list to the user

    locationSelected = () => {
        this.fillRoutes();
        this.fillLanes();
    }
    
    routeSelected = () => {
        this.fillLanes();
    }

    fillRoutes = () => {
        const request = () => getRoutes(this.state.location);
        const then = ({data}) => {
            console.log("ROUTE DATA FOR MESSAGE FILTER", data);
            const cleaned = data.map(v => v.Route);
            cleaned.unshift("None");
            this.setState({routes: cleaned, route: ""});
        };
        this.context.runProcessing(request, then, "getRoutes");
    }

    fillLanes = () => {
        const request = () => getLanes({location: this.state.location, route: [this.state.route]});
        const then = ({data}) => {
            const cleaned = data.map(v => v.laneGate);
            cleaned.unshift("None");
            this.setState({lanes: cleaned, lane: ""});
        };
        this.context.runProcessing(request, then, "getLanes");
    }

    //
    // set the filter values if they've been used before
    //
    componentDidMount(){
        if(this.props.filterValues){
            this.setState({...this.props.filterValues});
        }
    }

    applyFilter = () => {        
        this.setState({locationError: false}, () => {
            const values = {...this.state};
            this.props.applyFilter(values, this.props.toggleFilter);
        });
    }

    resetFilter = () => {
        this.setState({
            location: "",
            routes: [],
            route: "",
            lanes: [],
            lane: "",
            startDate: new Date(),
            endDate: new Date()
        });
    }

    render(){

        // at some point in the future, this app might be copied or extended
        // to interact with non-bus data/users
        const isBus = this.context.user.groupid === "BUS";

        return (
            <div className="filter">
                <div className="filter-field form-element-horizontal">
                    <label>Location</label>
                    <LocationDropDown 
                        setFocus={true}
                        selected={this.state.location}
                        updateValue={this.updateValue}
                        hasAllOption={true}
                    />
                </div>
                {
                    isBus
                    ? <>
                        <div className="filter-field form-element-horizontal">
                            <label>Route</label>
                            <select style={{width: "200px"}} value={this.state.route} name="route" onChange={this.updateValue}>
                            {
                                this.state.routes.map((route, index) => {
                                    return <option key={index} value={route}>{route}</option>
                                })
                            }
                            </select>
                        </div>
                        <div className="filter-field form-element-horizontal">
                            <label>Lane</label>
                            <select style={{width: "200px"}} value={this.state.lane} name="lane" onChange={this.updateValue}>
                            {
                                this.state.lanes.map((lane, index) => {
                                    return <option key={index} value={lane}>{lane}</option>
                                })
                            }
                            </select>
                        </div>
                    </>
                    : null
                }
                <div className="filter-field form-element-horizontal">
                    <label>Start Date</label>
                    <div>
                        <DateInput 
                            name="startDate"
                            value={this.state.startDate}
                            onChange={this.updateValue}
                        />
                    </div>
                </div>
                <div className="filter-field form-element-horizontal">
                    <label>End Date</label>
                    <div>
                        <DateInput 
                            name="endDate"
                            value={this.state.endDate}
                            onChange={this.updateValue}
                        />
                    </div>
                </div>
                <div className="filter-bar">
                    <div className="option  " onClick={this.resetFilter}>Reset</div>
                    <div className="option  " onClick={this.applyFilter}>Apply Filter</div>
                </div>
            </div>
        );
    }
}